import memoizeOne from 'memoize-one';

const minSample = 10;
const maxSample = 50;

let ttis: number[] = [];
const calcTTI = memoizeOne((sample) =>
  // @ts-expect-error FIXME TS7006
  ttis.length >= minSample ? sample.reduce((result, value) => result + value, 0) / ttis.length : 0,
);
export const resetTTI = () => {
  ttis = [];
};
export const getTTI = (): number => calcTTI(ttis);
export const getTTIs = (): number[] => ttis;

export const measureTTI = () => {
  if (window?.requestIdleCallback) {
    const start = Date.now();
    window.requestIdleCallback(() => {
      const time = Math.floor(Date.now() - start);
      ttis = [...ttis, time].slice(-maxSample);
    });
  }
};
